import type { DocumentMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import type { DocumentMetadataUserEditPutData } from 'features/knowledgeDocumentViewer/utils/buildDocumentMetadataUserEditPut'
import { documentMetadataUserEditByEntryId } from 'features/knowledgeDocumentViewer/utils/documentEntryLookups'
import type { RolodexEntryPutJson } from 'types'
import { RolodexEntryType } from 'types'

export type SeedDocumentMetadataUserEditMutate = (
  key: [string, string],
  data: DocumentMetadataUserEditEntry[],
  opts: { revalidate: boolean }
) => Promise<unknown>

function putToLoadEntry(
  put: RolodexEntryPutJson<DocumentMetadataUserEditPutData>
): DocumentMetadataUserEditEntry {
  return {
    entry: {
      id: put.id,
      type: RolodexEntryType.DOCUMENT_METADATA_USER_EDIT,
      data: put.data,
      tags: put.tags,
    },
  }
}

/** Seed per-document user-edit SWR keys (inactive siblings miss filter revalidate). */
export async function seedDocumentMetadataUserEditCaches({
  endpoint,
  siteId,
  puts,
  mutate,
}: {
  endpoint: string
  siteId: string
  puts: readonly RolodexEntryPutJson<DocumentMetadataUserEditPutData>[]
  mutate: SeedDocumentMetadataUserEditMutate
}): Promise<void> {
  await Promise.all(
    puts.map((put) => {
      const loadOptions = documentMetadataUserEditByEntryId(put.id, {
        site: siteId,
      })
      const key: [string, string] = [endpoint, JSON.stringify(loadOptions)]
      return mutate(key, [putToLoadEntry(put)], { revalidate: false })
    })
  )
}
